function IconMenuDown() {
  return (
    <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0.0134277H20L9.9251 10.0134L0 0.0134277Z" fill="currentColor" />
    </svg>
  );
}

export { IconMenuDown };
